import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { ColumnChartLoading } from '../../../../../../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart.loading';
import { HtmlTable } from '../../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Loading } from '../../../../../../../../CommonComponents/OPL/Loading/Loading';
import { Shimmer } from '../../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { ModalWrapper } from './components/ModalWrapper/ModalWrapper';

interface Props {
  onClose(): void;
}

export const BenefitsModalLoading = ({ onClose }: Props) => {
  return (
    <ModalWrapper onClose={onClose}>
      <>
        <Box mb="24" p="24">
          <ColumnChartLoading isStacked categoriesCount={1} chartHeight={280} />
        </Box>

        <HtmlTable variant="embedded" pb="24">
          <table>
            <thead>
              <tr>
                <th>
                  <Shimmer width="80px" height={24} />
                </th>
                <th>
                  <Shimmer width="50px" height={24} />
                </th>
                <th>
                  <Shimmer width="55px" height={24} />
                </th>
                <th>
                  <Shimmer width="55px" height={24} />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={4}>
                  <Box p="16">
                    <Loading />
                  </Box>
                </td>
              </tr>
            </tbody>
          </table>
        </HtmlTable>
      </>
    </ModalWrapper>
  );
};
